import React from 'react'
import styled from 'styled-components'

import Button from '../Button'

type TFallback = {
  error: Error
  resetErrorBoundary: () => void
}

const Wrapper = styled.div`
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  background: #c00;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  cursor: help;
  overflow-y: hidden;
`

const isDev = /localhost/.test(window.location.href)

const Fallback = (props: TFallback): React.ReactElement => {
  const { error, resetErrorBoundary } = props
  return (
    <Wrapper title={`${error.toString()}`}>
      <div>
        <i className="fa fa-2x fa-exclamation-triangle" />
      </div>

      <div>
        <Button textOnly icon="far fa-refresh" onClick={resetErrorBoundary}>
          {i18n.t(`try_again_error_boundary`, `Erneut versuchen`)}
        </Button>
      </div>

      {/* {isDev && (
        <div className="flex-fill" style={{ overflowY: "auto" }}>
          <pre>{error.message}</pre>
          <pre>{componentStack}</pre>
        </div>
      )} */}
    </Wrapper>
  )
}

export default Fallback
